!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("vega-lite"), require("react-vega")) : "function" == typeof define && define.amd ? define(["react", "vega-lite", "react-vega"], t) : "object" == typeof exports ? exports.ReactVegaLite = t(require("react"), require("vega-lite"), require("react-vega")) : e.ReactVegaLite = t(e.React, e.vl, e.ReactVega);
}("undefined" != typeof self ? self : this, function (e, t, r) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var a = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 2);
  }([function (e, t, r) {
    "use strict";

    var n = r(1),
        a = r.n(n),
        o = r(4),
        c = (r.n(o), r(5)),
        u = r.n(c),
        i = function i(e) {
      var t = Object.assign({}, e),
          r = Object.assign({}, e.spec);
      return e.data && (r.data = e.data, delete t.data), t.spec = o.compile(r).spec, a.a.createElement(u.a, t);
    };

    i.propTypes = u.a.propTypes, t.a = i;
  }, function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    e.exports = r(3);
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r.d(t, "createClassFromLiteSpec", function () {
      return o;
    });
    var n = r(0),
        a = r(6);
    t.default = n.a;
    var o = a.a;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    function n() {
      function e(e) {
        return o.a.createElement(c.a, u({
          spec: t
        }, e));
      }

      var t = 1 === arguments.length ? arguments.length <= 0 ? void 0 : arguments[0] : arguments.length <= 1 ? void 0 : arguments[1],
          r = Object.assign({}, c.a.propTypes);
      return delete r.spec, e.getSpec = function () {
        return t;
      }, e.propTypes = r, e;
    }

    t.a = n;

    var a = r(1),
        o = r.n(a),
        c = r(0),
        u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    };
  }]).default;
});